module.exports = __webpack_public_path__ + "static/media/carno-logo-white.697cc763.png";